<template>
    <breeze-authenticated-layout>
        <template #header>
            <div class="flex justify-between items-center">
                <h2 class="font-semibold text-xl text-gray-800 leading-tight">
                    Coach Profile
                </h2>
            </div>
        </template>

        <div class="py-12">
            <div class="max-w-7xl mx-auto sm:px-6 lg:px-8">
                <div class="bg-white overflow-hidden shadow-sm sm:rounded-lg">
                    <div class="p-6 bg-white border-b border-gray-200">
                        <div class="flex flex-col">
                            <div class="flex flex-col md:flex-row justify-start items-start shadow-md mb-5 p-5">
                                <ul class="flex-1 w-full flex-shrink-0 order-2 md:order-1">
                                    <li class="my-2 flex justify-between items-center border-b border-gray-600">
                                        <span class="font-semibold" for="">First Name</span>
                                        <span>{{ coach.first_name }}</span>
                                    </li>
                                    <li class="my-2 flex justify-between items-center border-b border-gray-600">
                                        <span class="font-semibold" for="">Last Name</span>
                                        <span>{{ coach.last_name }}</span>
                                    </li>
                                    <li class="my-2 flex justify-between items-center border-b border-gray-600">
                                        <span class="font-semibold" for="">Email</span>
                                        <span>{{ coach.email }}</span>
                                    </li>
                                    <li class="my-2 flex justify-between items-center border-b border-gray-600">
                                        <span class="font-semibold" for="">Country</span>
                                        <span>{{ coach.country ?? 'N/A' }}</span>
                                    </li>
                                    <li class="my-2 flex justify-between items-center border-b border-gray-600">
                                        <span class="font-semibold" for="">City</span>
                                        <span>{{ coach.city ?? 'N/A'}}</span>
                                    </li>
                                    <li class="my-2 flex justify-between items-center border-b border-gray-600">
                                        <span class="font-semibold" for="">Registered at</span>
                                        <span>{{ coach.created_at }}</span>
                                    </li>
                                </ul>
                                <div class="flex-1 w-full flex-shrink-0 order-1 md:order-2 inline-flex md:justify-end">
                                    <img
                                        :src="coach.profile_photo_url"
                                        :alt="coach.name"
                                        class="
                                            object-cover
                                            w-40
                                            h-40
                                            rounded
                                            shadow
                                        "
                                    />
                                </div>
                            </div>
                            <div
                                class="-my-2 overflow-x-auto sm:-mx-6 lg:-mx-8"
                            >
                                <div
                                    class="
                                        py-2
                                        align-middle
                                        inline-block
                                        min-w-full
                                        sm:px-6
                                        lg:px-8
                                    "
                                >
                                    <div
                                        class="
                                            shadow
                                            overflow-hidden
                                            border-b border-gray-200
                                            sm:rounded-lg
                                        "
                                    >
                                        <table
                                            class="
                                                min-w-full
                                                divide-y divide-gray-200
                                            "
                                        >
                                            <thead class="bg-gray-50">
                                                <tr>
                                                    <th
                                                        scope="col"
                                                        class="
                                                            px-6
                                                            py-3
                                                            text-left text-xs
                                                            font-medium
                                                            text-gray-500
                                                            uppercase
                                                            tracking-wider
                                                        "
                                                    >
                                                        #
                                                    </th>
                                                    <th
                                                        scope="col"
                                                        class="
                                                            px-6
                                                            py-3
                                                            text-left text-xs
                                                            font-medium
                                                            text-gray-500
                                                            uppercase
                                                            tracking-wider
                                                        "
                                                    >
                                                        Name
                                                    </th>
                                                    <th
                                                        scope="col"
                                                        class="
                                                            px-6
                                                            py-3
                                                            text-left text-xs
                                                            font-medium
                                                            text-gray-500
                                                            uppercase
                                                            tracking-wider
                                                        "
                                                    >
                                                        Email
                                                    </th>
                                                    <th
                                                        scope="col"
                                                        class="
                                                            px-6
                                                            py-3
                                                            text-left text-xs
                                                            font-medium
                                                            text-gray-500
                                                            uppercase
                                                            tracking-wider
                                                        "
                                                    >
                                                        Image
                                                    </th>
                                                    <th
                                                        scope="col"
                                                        class="
                                                            px-6
                                                            py-3
                                                            text-left text-xs
                                                            font-medium
                                                            text-gray-500
                                                            uppercase
                                                            tracking-wider
                                                        "
                                                    >
                                                        registered at
                                                    </th>
                                                </tr>
                                            </thead>
                                            <tbody
                                                class="
                                                    bg-white
                                                    divide-y divide-gray-200
                                                "
                                            >
                                                <tr
                                                    v-for="(
                                                        user, index
                                                    ) in coach.users"
                                                    :key="index"
                                                >
                                                    <td
                                                        class="
                                                            px-6
                                                            py-4
                                                            whitespace-nowrap
                                                        "
                                                    >
                                                        {{ index + 1 }}
                                                    </td>
                                                    <td
                                                        class="
                                                            px-6
                                                            py-4
                                                            whitespace-nowrap
                                                        "
                                                    >
                                                        {{ user.first_name }}
                                                        {{ user.last_name }}
                                                    </td>
                                                    <td
                                                        class="
                                                            px-6
                                                            py-4
                                                            whitespace-nowrap
                                                        "
                                                    >
                                                        {{ user.email }}
                                                    </td>
                                                    <td
                                                        class="
                                                            px-6
                                                            py-4
                                                            whitespace-nowrap
                                                        "
                                                    >
                                                        <img
                                                            :src="
                                                                user.profile_photo_url
                                                            "
                                                            class="
                                                                w-8
                                                                h-8
                                                                rounded-full
                                                                object-cover
                                                            "
                                                            alt=""
                                                        />
                                                    </td>
                                                    <td
                                                        class="
                                                            px-6
                                                            py-4
                                                            whitespace-nowrap
                                                        "
                                                    >
                                                        {{ user.created_at }}
                                                    </td>
                                                </tr>
                                            </tbody>
                                        </table>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </breeze-authenticated-layout>
</template>
<script>
import BreezeAuthenticatedLayout from "@/Layouts/Authenticated";
export default {
    props: {
        coach: Array,
    },
    components: {
        BreezeAuthenticatedLayout,
    },
};
</script>
